'use client';

import React from 'react';
import type { CmsContentBlock } from '@/lib/cms';
import LexicalRichText from './LexicalRichText';
import CmsTable from './CmsTable';

/** Renders a post's `content` blocks array in order, dispatching each block to its matching renderer. */
export default function CmsContent({ blocks }: { blocks: CmsContentBlock[] }) {
  return (
    <>
      {blocks.map((block) => {
        switch (block.blockType) {
          case 'richText':
            return <LexicalRichText key={block.id} root={block.content.root} />;
          case 'table':
            return <CmsTable key={block.id} block={block} />;
          default:
            return null;
        }
      })}
    </>
  );
}
